const colors = require('tailwindcss/colors');

let spacingValues= {};

for (let i = 0; i <= 1000; i += 4) {
    spacingValues[i] = `${i / 10}rem`;
}

module.exports = {

    colors: {
        // start new palette
        primary: {
            DEFAULT: '#334076',
            80: '#5C6691',
            60: '#858CAD',
            40: '#ADB3C8',
            20: '#D6D9E4',
            5: '#F5F5F8',
        },

        secondary: {
                DEFAULT: '#47A83A',
                80: '#6AB75F',
                60: '#91CB89',
                40: '#B5DCB0',
                20: '#DAEED8',
                5: '#F6FBF5',
        },


        semantic: {
            success: {
                DEFAULT: '#63C767',
                dark: '#569E59',
                light: '#DCFFDD',
            },

            info: {
                DEFAULT: '#39BAE5',
                dark: '#086D8E',
                light: '#D9F6FF',
            },

            warning: {
                DEFAULT: '#F6993F',
                dark: '#A85918',
                light: '#FCD9B6',
            },

            error: {
                DEFAULT: '#EF5753',
                dark: '#B62A27',
                light: '#FFD0CE',
            },
        },

        vdab: {
            DEFAULT: '#004475',
            light: '#36698E'
        },

        zapier: {
            DEFAULT: '#FF4A00',
            light: '#F56E36',
        },

        officient: {
            DEFAULT: '#465DF1',
            light: '#7283F2',
        },

        seek: {
            DEFAULT: '#e60278',
            light: '#fd0585',
        },

        neutral: {
            black: '#313442',
            white: '#FDFDFD',
            grey: '#4C4F5D',
        },

        black: '#313442',
        white: '#FDFDFD',

        gradient: {
            1: '#5C6691',
            2: '#5F7687',
            3: '#62867D',
            4: '#649773',
            5: '#67A769',
            6: '#6AB75F',
        },

        // end new palette

        transparent: 'transparent',
        current: 'currentColor',

        beige: {
            light: '#F6F6F4',
        },

        grey: {
            darkest: '#38464B',
            darker: '#596266',
            dark: '#728389',
            DEFAULT: '#758A92',
            soft: '#A9C2CB',
            light: '#C5D3D9',
            lighter: '#DDE4E6',
            lightest: '#F4F6F6',
        },

        green: {
            darker: '#158105',
            dark: '#47A83A',
            DEFAULT: '#58CC47',
            light: '#6BD65B',
            lighter: '#BEEDAE',
            'super-light': '#DCF8D8',
            lightest: '#F1FBEF',
            blue: '#4EC67C', //used in staging
            ...colors.emerald,
        },

        blue: {
            lightest: '#EFFBFF',
            lighter: '#d9f6ff',
            light: '#A4E9FF',
            DEFAULT: '#39BAE5',
            dark: '#1E7B99',
            darker: '#086D8E',
            darkest: '#044c63',
            ...colors.blue,
        },

        cyan: {
            DEFAULT: '#3eafa8',
        },

        yellow: {
            50: '#fffbeb',
            100: '#fef3c7',
            200: '#fde68a',
            300: '#fcd34d',
            400: '#fbbf24',
            500: '#f59e0b',
            600: '#d97706',
            700: '#b45309',
            800: '#92400e',
            900: '#78350f',
            DEFAULT: '#F9B800',
            light: '#FFC627',
            lighter: '#FFDD7F',
            lightest: '#FFF5DB',
            // ...colors.amber,
        },

        red: {
            darkest: '#3b0d0c',
            darker: '#621b18',
            dark: '#cc1f1a',
            DEFAULT: '#e3342f',
            light: '#ef5753',
            lighter: '#f9acaa',
            lightest: '#fcebea',
            ...colors.red,
        },

        orange: {
            darkest: '#462a16',
            darker: '#613b1f',
            dark: '#de751f',
            DEFAULT: '#f6993f',
            light: '#faad63',
            lighter: '#fcd9b6',
            lightest: '#fff5eb',
        },

        teal: {
            darkest: '#0d3331',
            darker: '#20504f',
            dark: '#38a89d',
            DEFAULT: '#4dc0b5',
            light: '#64d5ca',
            lighter: '#a0f0ed',
            lightest: '#e8fffe',
        },

        indigo: {
            darkest: '#191e38',
            darker: '#2f365f',
            dark: '#5661b3',
            DEFAULT: '#6574cd',
            light: '#7886d7',
            lighter: '#b2b7ff',
            lightest: '#e6e8ff',
            ...colors.indigo,
        },

        purple: {
            darkest: '#21183c',
            darker: '#382b5f',
            dark: '#794acf',
            DEFAULT: '#9561e2',
            light: '#a779e9',
            lighter: '#d6bbfc',
            lightest: '#f3ebff',
            ...colors.violet,
        },

        pink: {
            darkest: '#451225',
            darker: '#6f213f',
            dark: '#eb5286',
            DEFAULT: '#f66d9b',
            light: '#fa7ea8',
            lighter: '#ffbbca',
            lightest: '#ffebef',
            ...colors.pink,
        },
    },

    textColor: theme => theme('colors'),
    backgroundColor: theme => theme('colors'),

    screens: {
        'xs': '420px',
        'sm': '640px',
        'md': '768px',
        'mdplus': '900px',
        'lg': '1024px',
        'xl': '1280px',
        'xxl': '1380px',
        'monster': '1920px',
        'print': {'raw': 'print'},
    },

    fontFamily: {
        'auto': 'auto',
        'sans': [
            'Montserrat',
            'sans-serif',
        ],
        'serif': [
            'Constantia',
            'Lucida Bright',
            'Lucidabright',
            'Lucida Serif',
            'Lucida',
            'DejaVu Serif',
            'Bitstream Vera Serif',
            'Liberation Serif',
            'Georgia',
            'serif',
        ],
        'mono': [
            'Menlo',
            'Monaco',
            'Consolas',
            'Liberation Mono',
            'Courier New',
            'monospace',
        ],
    },

    fontSize: {
        '10': '1rem',
        '12': '1.2rem',
        '14': '1.4rem',
        '16': '1.6rem',
        '18': '1.8rem',
        '20': '2.0rem',
        '24': '2.4rem',
        '28': '2.8rem',
        '30': '3rem',
        '32': '3.2rem',
        '40': '4rem',
        '48': '4.8rem',

        // start new sizes
        big: '3.8rem',
        'heading-1': '2.8rem',
        'heading-2': '2.4rem',
        'body': '1.8rem',
        'body-sm': '1.4rem',
        // end new sizes
    },

    zIndex: {
        'bottom': -999,
        '-1': '-1',
        '0': 0,
        '10': 10,
        '20': 20,
        '30': 30,
        '40': 40,
        '50': 50,
        '60': 60,
        '70': 70,
        '80': 80,
        '90': 90,
        '100': 100,
        'top': 999,
    },

    backgroundSize: {
        'auto': 'auto',
        'cover': 'cover',
        'contain': 'contain',
        'contain-x': '100% auto',
    },

    borderWidth: {
        DEFAULT: '0.15rem',
        '0': '0',
        '2': '0.2rem',
        '3': '0.3rem',
        '4': '0.4rem',
        '6': '0.6rem',
        '8': '0.8rem',
        '12': '1.2rem',
        '16': '1.6rem',
    },

    opacity: {
        '0': '0',
        '5': '.05',
        '10': '.1',
        '25': '.25',
        '30': '.3',
        '50': '.5',
        '75': '.75',
        '85': '.85',
        '100': '1',
    },

    borderRadius: {
        DEFAULT: '.6rem',
        '6': '0.6rem', // same as DEFAULT
        '4': '0.4rem',
        '32': '3.2rem',
    },

    minWidth: {
        ...spacingValues,
        'full': '100%',
    },

    minHeight: {
        ...spacingValues,
        'full': '100%',
        'screen': '100vh',
    },

    maxWidth: {
        ...spacingValues,
        '1/3': '33.33333%',
        'full': '100%',
        'prose25': '25ch',
    },

    maxHeight: {
        ...spacingValues,
        'full': '100%',
        'screen': '100vh',
        '5/6': '83.33333%', // TODO: Check why this value is not automatically compiled through tailwind. One usage in app/views/layouts/cookie-popup.blade.php
    },

    spacing: {
        ...spacingValues,
        '2': '0.2rem',
        '18': '1.8rem',
        // used for jobsite header
        '30pct': '30%',
        '40pct': '40%',
        '60pct': '60%',
        '100pct': '100%',
        'screen': '100vh',
        'svh': '100svh',
        'lvh': '100lvh',
        'dvh': '100dvh',
    },

    inset: {
        '0': '0',
        '16': '1.6rem',
        '1/2': '50%',
        'full': '100%',
    },

    cursor: {
        auto: 'auto',
        default: 'default',
        pointer: 'pointer',
        wait: 'wait',
        text: 'text',
        'not-allowed': 'not-allowed',
        grab: 'grab',
        grabbing: 'grabbing',
        move: 'move',
        help: 'help',
    },

    textShadow: {
        DEFAULT: '0 0 40px rgba(0, 0, 0, 0.2), 0 1px 2px rgba(0, 0, 0, 0.2)',
    },

    boxShadow: {
        DEFAULT: '0 0 11px rgba(51, 64, 118, 0.10), 0 1px 3px rgba(51, 64, 118, 0.09), 0 5px 8px rgba(51, 64, 118, 0.05), 0 12px 6px rgba(51, 64, 118, 0.01), -1px 7px 10px rgba(51, 64, 118, 0.00)',
        '3xl': '0 10px 20px -15px rgba(0, 0, 0, 0.1)',
    },
    dropShadow: {
        DEFAULT: ['0 0 11px rgba(51, 64, 118, 0.10)',
            '0 1px 3px rgba(51, 64, 118, 0.09)',
            '0 5px 8px rgba(51, 64, 118, 0.05)',
            '0 12px 6px rgba(51, 64, 118, 0.01)',
            '-1px 7px 10px rgba(51, 64, 118, 0.00)'
        ],
        '3xl': '0 10px 20px -15px rgba(0, 0, 0, 0.1)',
    },
    keyframes: {
        wiggle: {
            '0%, 100%': { transform: 'rotate(-2deg)' },
            '50%': { transform: 'rotate(2deg)' },
        }
    },
    animation: {
        wiggle: 'wiggle 1s ease-in-out infinite',
    },
};
